// import React from 'react';
import '../style/profile.css'
import Navbar from './navbar';
import React, { useState,useContext } from 'react';
import { AuthContext } from './auth/auth';


export  function Profile() {
  const { currentUser } = useContext(AuthContext);


  return (
    <>
    {currentUser ? (<div>You are not logged in </div>):(
    <div className='profile_page'>
      <Navbar/>
      {/* <Navbar2/> */}
      <div className='info_section'>
        <div className='Name_field'>
        Name Feild

        </div>
      
         <div className='User_info'>
           <div className='email_field'> email</div>
           <div className='Number_field'> phonenumber</div>
        </div>

      </div>
      <div className='Scan_result'>

        <div className='Profile_container'>           
             <h2>Subdomain Finder</h2>
             <div className="Scan_description" >
                 <p1>google.com</p1>
                 <p1>05 February 2023 1.09.22 AM</p1>
             </div>
             <button  className="download_button" > Download</button>  
        </div>

      

      </div>




    </div>)};
    </>
  );
}